// Central definition of sales-team roles so the UI and routing logic stay in sync.
// Add new roles here only — every page that needs to check or display roles imports from here.

export const SALES_ROLES = ['clm', 'bdo', 'sales_rep', 'crm', 'associate', 'leader'];

export const ROLE_LABELS = {
  clm: 'Core Leadership Member',
  bdo: 'Business Development Officer',
  sales_rep: 'Sales Representative',
  crm: 'Customer Relationship Manager',
  associate: 'Associate',
  leader: 'Leader', // legacy role, kept for backward compatibility with existing accounts
};

// Roles selectable when creating/editing a team member. 'leader' is intentionally
// excluded from new-creation dropdowns (legacy only) but still displays correctly
// for existing accounts via ROLE_LABELS.
export const ASSIGNABLE_ROLES = ['clm', 'bdo', 'sales_rep', 'crm', 'associate'];

export const isSalesRole = (role) => SALES_ROLES.includes(role);

export const roleLabel = (role) => ROLE_LABELS[role] || role;
